module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/hotel.jpg?0cdfb994";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/hotel.jpg
// module id = 2427
// module chunks = 0